export const BROADCAST_CHANNEL = 'hi-rasmus-browser-channel';

export const BROADCAST_MESSAGES = {
  // Send a signal to all tabs with this app opened to update auth token
  TOKEN_REVOCATION_BROADCAST_MESSAGE: 'auth-token-revocation',
  // Send a signal to all tabs in the Offline Mode to show syncToOnline loading spinner
  SYNC_TO_ONLINE_BROADCAST_MESSAGE: 'sync-to-online',
  RELOAD_PAGE_BROADCAST_MESSAGE: 'reload-page',
  // Send signal to all tabs with this app opened that user has logged out in one of the tabs
  USER_LOGOUT_BROADCAST_MESSAGE: 'user-logout',
  // Send signal to all tabs with this app opened that encryption keys have been filled
  ENCRYPTION_KEYS_FILLED_BROADCAST_MESSAGE: 'encryption-keys-filled',
  // Send signal to all tabs with this app opened that MFA has been enrolled
  MFA_ENROLLED_BROADCAST_MESSAGE: 'mfa-enrolled',
  // Send a signal to all open tabs that the auth session has been continued
  CONTINUE_AUTH_SESSION_BROADCAST_MESSAGE: 'continue-auth-session',
};
